exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-form-new-type-service-component .modal-form{max-width:640px;background-color:red}.modal-form-new-type-service-component .modal-form .modal-card-head{border:none;background-color:#fff}.modal-form-new-type-service-component .modal-form .modal-actions{margin-top:2rem;text-align:right}", ""]);

// exports
